import { AMLIncomeSource, type AMLFormValues } from "@repo/logic";
import i18n from "i18next";
import { boolean, mixed, object, string, type ObjectSchema } from "yup";

export const AMLQuestionsSchema: ObjectSchema<AMLFormValues> = object().shape({
    usaResident: boolean().required(),
    greenCardHolder: boolean().required(),
    politicallyExposed: boolean().required(),
    taxResidence: string().required(),
    taxNumber: string().when("taxResidence", {
        is: (residence: string) => residence !== "CZE",
        then: (schema) => schema.required(),
        otherwise: (schema) => schema.optional(),
    }),
    employmentType: string().required(),
    businessIncomeId: string().when("employmentType", {
        is: AMLIncomeSource.Business,
        then: (schema) => schema.required(),
        otherwise: (schema) => schema.optional(),
    }),
    otherIncomeId: string().when("employmentType", {
        is: AMLIncomeSource.Other,
        then: (schema) => schema.required(),
        otherwise: (schema) => schema.optional(),
    }),
    incomeSourceSpecification: string().when(["employmentType", "businessIncomeId", "otherIncomeId"], {
        is: (type: string, businessIncomeId: string, otherIncomeId: string) => {
            if (type === AMLIncomeSource.Business && businessIncomeId === "Jiné") return true;
            if (type === AMLIncomeSource.Other && otherIncomeId === "Jiné") return true;
            return false;
        },
        then: (schema) => schema.required(),
        otherwise: (schema) => schema.optional(),
    }),
    averageIncome: string().required(),
    propertySources: mixed<Record<number, boolean>>()
        .required()
        .test({
            test: (sources: Record<number, boolean> | undefined) => {
                if (!sources) return false;
                for (const source in sources) {
                    if (sources[source]) return true;
                }
                return false;
            },
            message: i18n.t("AML.amlQuestionaire.validation.propertySources"),
        }),
    propertySourceSpecification: string().when(["propertySources"], {
        is: (propertySources: Record<number, boolean>) => {
            // ID 8 = "Jiný majetek" -> StarpensionName: "Jiné"
            return propertySources[8] === true;
        },
        then: (schema) => schema.required(),
        otherwise: (schema) => schema.optional(),
    }),
    submitError: string().optional(),
});
